import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ExpensesData.css'
import 'jspdf-autotable';
import baseURL from '../../url';
import NewExpense from '../NewExpense/NewExpense';
export default function ExpensesData() {
    const [expenses, setExpenses] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [newAmount, setNewAmount] = useState('');
    const [newDescription, setNewDescription] = useState(0);
    const [expense, setExpense] = useState({});
    const [selectedSection, setSelectedSection] = useState('texto');

    useEffect(() => {
        fetchExpenses();

    }, []);


    const fetchExpenses = () => {
        fetch(`${baseURL}/expensesGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setExpenses(data.expenses || []);
                console.log(data.expenses)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const removeExpense = (idExpense) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/expenseDelete.php?idExpense=${idExpense}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire(
                                'Error!',
                                data.error,
                                'error'
                            );
                        } else {
                            Swal.fire(
                                '¡Eliminado!',
                                data.mensaje,
                                'success'
                            );
                            fetchExpenses();
                        }
                    })
                    .catch(error => {
                        console.error('Error al eliminar contacto:', error);
                        toast.error(error);

                    });
            }
        });
    };

    const abrirModal = (item) => {
        setExpense(item);
        setNewAmount(item.amount);
        setNewDescription(item.description);

        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };



    const handleUpdateText = (idExpense) => {
        const payload = {
            amount: newAmount !== '' ? newAmount : expense.amount,
            description: newDescription !== '' ? newDescription : expense.description,
        };

        fetch(`${baseURL}/expensePut.php?idExpense=${idExpense}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                    console.log(idExpense)
                } else {
                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    fetchExpenses();
                    cerrarModal();
                }
            })
            .catch(error => {
                console.log(error.message);
                toast.error(error.message);
            });
    };



    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };
    return (
        <div>
            <ToastContainer />
            <NewExpense />

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>

                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Cantidad</legend>
                                    <input
                                        type="number"
                                        placeholder='Cantidad'
                                        value={newAmount !== '' ? newAmount : expense.amount}
                                        onChange={(e) => setNewAmount(e.target.value)}
                                        step="0.1"
                                        min="0"
                                    />
                                </fieldset>
                                <fieldset className='w-100'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        type="text"
                                        placeholder='Descripción'
                                        value={newDescription !== 0 ? newDescription : expense.description}
                                        onChange={(e) => setNewDescription(e.target.value)}
                                    />
                                </fieldset>
                            </div>
                            <button className='btnPost' onClick={() => handleUpdateText(expense.idExpense)} >Guardar</button>
                        </div>
                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Gastos</th>
                            <th>Cantidad</th>
                            <th>Descripción</th>
                            <th>Fecha</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {expenses.map(item => (
                            <tr key={item.idExpense}>
                                <td>{item.idExpense}</td>
                                <td>{item.amount}</td>
                                <td>{item.description}</td>
                                <td>{item.date}</td>
                                <td>
                                    <button className='eliminar' onClick={() => removeExpense(item.idExpense)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>
    );
};
